<button class="przycisk-prostokat label" [ngClass]="[typ, rodzaj]" [style.padding-left]="paddingX"
  [style.padding-right]="paddingX" [style.padding-top]="paddingY" [style.padding-bottom]="paddingY"
  [class.disabled]="disabled" [disabled]="disabled">
  <span class="ikona-na-poczatku" [style.height]="iconHeight" *ngIf="ikonaNaPoczatku"
    [mmIkonaSvg]="ikonaNaPoczatku"></span>
  <span> {{label}}</span>

  <span class="ikona-na-koncu" [style.height]="iconHeight" *ngIf="ikonaNaKoncu" [ngClass]="ikonaNaKoncu"
    [mmIkonaSvg]="ikonaNaKoncu"></span>
</button>
